import { PanelBody, Panel, __experimentalBoxControl as BoxControl, TextControl, __experimentalNumberControl as NumberControl, ToggleControl } from "@wordpress/components";
import { __experimentalUnitControl as UnitControl } from "@wordpress/components";

import { __ } from "@wordpress/i18n";

/* eslint-disable react/prop-types */

import BControls from "./BControls";
import { BColor, BControlPro } from "../../../../wp-utils/v1/components";
// import Watermark from "./Watermark";

const Options = ({ preset, setPreset, isPremium }) => {
  const { options, plyrStyle, thumbInPause, hideYoutubeUI, hideControlsWhenPause, watermark } = preset?.preset || {};
  const { speed, autoplay, repeat, muted, resetOnEnd, seekTime, autoHideControl } = options;

  const setOptions = (option) => {
    const newOptions = { ...options, ...option };
    setPreset({ options: newOptions });
  };

  const setWatermark = (data = {}) => {
    const newWatermark = { ...watermark, ...data };
    setPreset({ watermark: newWatermark });
  };

  return (
    <>
      <Panel>
        <BControls preset={preset} setPreset={setPreset} />
        <PanelBody title={__("Settings", "ytp")} initialOpen={false}>
          <BControlPro Component={ToggleControl} isPremium={isPremium} label={__("Repeat", "ytp")} id="repeat" checked={repeat} onChange={() => setOptions({ repeat: !repeat })} />
          {/* <PanelRow>
            <label htmlFor="repeat" className="label">
              {__("Repeat", "ytp")}
            </label>
            <FormToggle id="repeat" checked={repeat} onChange={() => setOptions({ repeat: !repeat })} />
          </PanelRow> */}
          {!repeat && (
            // <PanelRow>
            //   <label htmlFor="resetOnEnd" className="label">
            //     {__("Reset On End", "ytp")}
            //   </label>
            //   <FormToggle id="resetOnEnd" checked={resetOnEnd} onChange={() => setOptions({ resetOnEnd: !resetOnEnd })} />
            // </PanelRow>
            <BControlPro
              Component={ToggleControl}
              label={__("Reset On End", "ytp")}
              isPremium={isPremium}
              id="resetOnEnd"
              checked={resetOnEnd}
              onChange={() => setOptions({ resetOnEnd: !resetOnEnd })}
            />
          )}
          {/* <PanelRow>
            <label htmlFor="autoplay" className="label">
              {__("Autoplay", "ytp")}
            </label>
            <FormToggle id="autoplay" checked={autoplay} onChange={() => setOptions({ autoplay: !autoplay })} />
          </PanelRow> */}
          <BControlPro
            Component={ToggleControl}
            isPremium={isPremium}
            label={__("Autoplay", "ytp")}
            id="autoplay"
            checked={autoplay}
            onChange={() => setOptions({ autoplay: !autoplay })}
          />
          <BControlPro Component={ToggleControl} isPremium={isPremium} label={__("Muted", "ytp")} id="muted" checked={muted} onChange={() => setOptions({ muted: !muted })} />
          <BControlPro
            Component={ToggleControl}
            isPremium={isPremium}
            label={__("Show thumbnail on pause", "ytp")}
            id="thumbInPause"
            checked={thumbInPause}
            onChange={() => setPreset({ thumbInPause: !thumbInPause })}
          />
          <BControlPro
            Component={ToggleControl}
            isPremium={isPremium}
            label={__("Show thumbnail on pause", "ytp")}
            id="thumbInPause"
            checked={thumbInPause}
            onChange={() => setPreset({ thumbInPause: !thumbInPause })}
          />
          <BControlPro
            Component={ToggleControl}
            isPremium={isPremium}
            label={__("Auto Hide Control", "ytp")}
            id="autoHideControl"
            checked={autoHideControl}
            onChange={() => setOptions({ autoHideControl: !autoHideControl })}
          />

          <BControlPro
            isPremium={isPremium}
            Component={NumberControl}
            label={__("Seek Time", "ytp")}
            isShiftStepEnabled={true}
            onChange={(seekTime) => setOptions({ seekTime })}
            shiftStep={1}
            value={seekTime}
          />
          {/* <PanelRow>
            <label className="label">{__("Seek Time", "ytp")}</label>
            <NumberControl isShiftStepEnabled={true} onChange={(seekTime) => setOptions({ seekTime })} shiftStep={1} value={seekTime} />
          </PanelRow> */}
          {/* <PanelRow>
            <div>
              <label>{__("Speed", "ytp")}</label>
            </div>
            <TextControl value={options?.speed?.options} onChange={(options) => setOptions({ speed: { ...speed, options: options.split(",") } })} />
          </PanelRow> */}
          <BControlPro
            isPremium={isPremium}
            Component={TextControl}
            label={__("Speed", "ytp")}
            value={options?.speed?.options}
            onChange={(options) => setOptions({ speed: { ...speed, options: options.split(",") } })}
          />
          <BControlPro
            Component={ToggleControl}
            isPremium={isPremium}
            label={__("Hide youtube UI (Experimental)", "ytp")}
            checked={hideYoutubeUI}
            onChange={() => setPreset({ hideYoutubeUI: !hideYoutubeUI })}
          />
          <BControlPro
            Component={ToggleControl}
            isPremium={isPremium}
            label={__("Hide controls in pause", "ytp")}
            checked={hideControlsWhenPause}
            onChange={() => setPreset({ hideControlsWhenPause: !hideControlsWhenPause })}
          />
        </PanelBody>
        {/* <Watermark setWatermark={setWatermark} watermark={watermark} /> */}
        <PanelBody title={__("Style", "ytp")} initialOpen={false}>
          <UnitControl
            step="1"
            value={plyrStyle?.borderRadius}
            onChange={(borderRadius) => setPreset({ plyrStyle: { ...plyrStyle, borderRadius } })}
            label={__("Round Corners", "ytp")}
            labelPosition="side"
          />

          {/* <PanelRow>
            <label htmlFor="maincolor">{__("Main Color", "ytp")}</label>
            <BColor value={plyrStyle?.["--plyr-color-main"]} onChange={(brandColor) => setPreset({ plyrStyle: { ...plyrStyle, "--plyr-color-main": brandColor } })} defaultColor="#00b2ff" />
          </PanelRow> */}
        </PanelBody>
        <PanelBody title={__("Large Play Button Style", "ytp")}>
          <BControlPro
            Component={UnitControl}
            isPremium={isPremium}
            labelPosition="side"
            label={__("Corner Round", "ytp")}
            value={plyrStyle?.["plyr__control--overlaid"]?.borderRadius}
            onChange={(borderRadius) => setPreset({ plyrStyle: { ...plyrStyle, "plyr__control--overlaid": { ...plyrStyle?.["plyr__control--overlaid"], borderRadius } } })}
          />
          {/* <PanelRow>
            <UnitControl
              labelPosition="side"
              label={__("Corner Round", "ytp")}
              value={plyrStyle?.["plyr__control--overlaid"]?.borderRadius}
              onChange={(borderRadius) => setPreset({ plyrStyle: { ...plyrStyle, "plyr__control--overlaid": { ...plyrStyle?.["plyr__control--overlaid"], borderRadius } } })}
            />
          </PanelRow> */}

          <BControlPro
            Component={BoxControl}
            isPremium={isPremium}
            values={plyrStyle?.["plyr__control--overlaid"]?.padding}
            onChange={(padding) => setPreset({ plyrStyle: { ...plyrStyle, "plyr__control--overlaid": { ...plyrStyle?.["plyr__control--overlaid"], padding } } })}
            label={__("Padding", "ytp")}
          />

          {/* <BoxControl
            values={plyrStyle?.["plyr__control--overlaid"]?.padding}
            onChange={(padding) => setPreset({ plyrStyle: { ...plyrStyle, "plyr__control--overlaid": { ...plyrStyle?.["plyr__control--overlaid"], padding } } })}
            label={__("Padding", "ytp")}
          /> */}

          <BControlPro
            Component={UnitControl}
            isPremium={isPremium}
            labelPosition="side"
            label={__("Icon Size", "ytp")}
            value={plyrStyle?.["plyr__control--overlaid svg"]?.height}
            onChange={(height) =>
              setPreset({ plyrStyle: { ...plyrStyle, "plyr__control--overlaid svg": { ...plyrStyle?.["plyr__control--overlaid svg"], height, width: height } } })
            }
          />

          {/* <PanelRow>
            <UnitControl
              labelPosition="side"
              label={__("Icon Size", "ytp")}
              value={plyrStyle?.["plyr__control--overlaid svg"]?.height}
              onChange={(height) =>
                setPreset({ plyrStyle: { ...plyrStyle, "plyr__control--overlaid svg": { ...plyrStyle?.["plyr__control--overlaid svg"], height, width: height } } })
              }
            />
          </PanelRow> */}

          {/* <PanelRow>
            <label>{__("Background", "ytp")}</label> */}
          <BControlPro
            Component={BColor}
            label={__("Background", "ytp")}
            isPremium={isPremium}
            value={plyrStyle?.["plyr__control--overlaid"]?.background}
            onChange={(background) => setPreset({ plyrStyle: { ...plyrStyle, "plyr__control--overlaid": { ...plyrStyle?.["plyr__control--overlaid"], background } } })}
          />
          {/* </PanelRow> */}
        </PanelBody>

        {/* <PanelBody title={__("End Screen", "ytp")} initialOpen={false}>
          <PanelRow>
            <label className="label" htmlFor="endscreen">
              {__("Enable Endscreen", "ytp")}
            </label>
            <FormToggle id="endscreen" checked={endscreen} onChange={() => setPreset({ endscreen: !endscreen })} />
          </PanelRow>
          {endscreen && (
            <>
              <PanelRow>
                <label htmlFor="" className="label display-block">
                  {__("endscreen text", "ytp")}
                </label>
              </PanelRow>
              <PanelRow>
                <TextControl value={endscreenText} onChange={(endscreenText) => setPreset({ endscreenText })} />
              </PanelRow>
              <PanelRow>
                <label htmlFor="" className="label display-block">
                  {__("endscreen text link", "ytp")}
                </label>
              </PanelRow>
              <PanelRow>
                <TextControl value={endscreenTextLink} onChange={(endscreenTextLink) => setPreset({ endscreenTextLink })} />
              </PanelRow>
            </>
          )}
        </PanelBody>

        <PanelBody title={__("Watermark", "ytp")} initialOpen={false}>
          <PanelRow>
            <label className="label" htmlFor="watermark">
              {__("Watermark", "ytp")}
            </label>
            <FormToggle
              id="watermark"
              checked={watermark?.enabled}
              onChange={() =>
                setPreset({
                  watermark: {
                    ...watermark,
                    enabled: !watermark?.enabled,
                  },
                })
              }
            />
          </PanelRow>
          {watermark?.enabled && (
            <>
              <PanelRow className="inline">
                <label htmlFor="" className="label">
                  {__("Type")}
                </label>
                <SelectControl
                  value={watermark?.type}
                  options={[
                    { label: "Uesr Email", value: "email" },
                    { label: "User Name", value: "name" },
                    { label: "Custom Text", value: "text" },
                  ]}
                  onChange={(type) => setPreset({ watermark: { ...watermark, type } })}
                />
              </PanelRow>
              {watermark?.type === "text" && (
                <PanelRow>
                  <TextControl value={watermark?.text} onChange={(text) => setPreset({ watermark: { ...watermark, text } })} />
                </PanelRow>
              )}

              <PanelRow>
                <label htmlFor="" className="label display-block">
                  {__("Text Color", "ytp")}
                </label>
                <BColor defaultColor="#f00" value={watermark?.color} onChange={(color) => setPreset({ watermark: { ...watermark, color } })} />
              </PanelRow>
            </>
          )}
        </PanelBody> */}
      </Panel>
    </>
  );
};

export default Options;
